import { createContext } from 'react';
import { WidgetWrapper } from '../shared/components/WidgetWrapper';
import { InquiriesOptions, WidgetType } from '../shared/types';
import { BaseWidgetProps } from '../widgets';
import { TableView } from './TableView';
import { useInquiriesWidget } from './useInquiriesWidget';

interface Props extends BaseWidgetProps {
  options?: InquiriesOptions;
}

export const InquiriesWidgetContext = createContext<ReturnType<
  typeof useInquiriesWidget
> | null>(null);

export function InquiriesWidget({
  color,
  customTitle,
  options,
  widgetId,
}: Props) {
  const inquiriesWidget = useInquiriesWidget({ options, widgetId });

  return (
    <InquiriesWidgetContext.Provider value={inquiriesWidget}>
      <WidgetWrapper
        widgetId={widgetId}
        loading={inquiriesWidget.loading}
        settings={options?.componentSettings}
        customColor={color}
        type={WidgetType.TrackInquiries}
        style="default"
        header={customTitle ?? 'Tracked inquiries'}
      >
        <TableView />
      </WidgetWrapper>
    </InquiriesWidgetContext.Provider>
  );
}
